import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Sample backend data - replace with actual API call
const mockBackendData = {
  title: "Our Projects",
  project: [
    {
      id: 1,
      name: "Legal Help for Workers",
      description: "We provide free legal assistance to laborers facing workplace issues such as wage disputes, contract violations, and unsafe working conditions. Our team of volunteer lawyers helps workers navigate the legal system and fight for their rights.",
      image: "https://www.hrw.org/sites/default/files/styles/16x9_large/public/multimedia_images_2015/india0814_coverimage.jpg?itok=uWo9ZHca"
    },
    {
      id: 2,
      name: "Rights Awareness Campaign",
      description: "Our educational workshops teach laborers about their legal rights, helping them understand minimum wage laws, workplace safety regulations, and how to address exploitation. Knowledge is the first step toward empowerment.",
      image: "https://images.pexels.com/photos/860577/pexels-photo-860577.jpeg?cs=srgb&dl=pexels-jodaarba-860577.jpg&fm=jpg"
    },
    {
      id: 3,
      name: "Emergency Support Fund",
      description: "When workers face sudden crises like medical emergencies, job loss, or natural disasters, our emergency fund provides immediate financial assistance to help them through difficult times without falling into debt.",
      image: "https://st3.depositphotos.com/3279155/16919/i/450/depositphotos_169192510-stock-photo-children-in-semien-mountains-ethiopia.jpg"
    }
  ]
};

// Async thunk to fetch projects from backend
export const fetchProjects = createAsyncThunk(
  'projects/fetchProjects',
  async (_, { rejectWithValue }) => {
    try {
      // In a real implementation, replace this with an actual API call
      // const response = await fetch('YOUR_API_ENDPOINT/projects');
      // const data = await response.json();
      
      // For now, we'll simulate an API call with a delay
      await new Promise(resolve => setTimeout(resolve, 300));
      return mockBackendData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  title: "",
  project: [],
  status: 'idle', // 'idle', 'loading', 'succeeded', 'failed'
  error: null
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjects.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.title = action.payload.title;
        state.project = action.payload.project;
      })
      .addCase(fetchProjects.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  }
});

export default projectSlice.reducer;
